import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { isConsult } from "../lib/api";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const STORAGE_KEY = "cg_cart";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = useCallback((beer, qty = 1, size = null) => {
    const key = size ? `${beer.id}|${size}` : beer.id;
    setItems((prev) => {
      const found = prev.find((i) => (i.key || i.id) === key);
      if (found) {
        return prev.map((i) => ((i.key || i.id) === key ? { ...i, quantity: i.quantity + qty } : i));
      }
      const name = size ? `${beer.name} · Talla ${size}` : beer.name;
      return [...prev, { key, id: beer.id, size, name, price: beer.price, image_url: beer.image_url, style: beer.style, consult: isConsult(beer), quantity: qty }];
    });
  }, []);

  const removeItem = useCallback((key) => {
    setItems((prev) => prev.filter((i) => (i.key || i.id) !== key));
  }, []);

  const setQuantity = useCallback((key, quantity) => {
    setItems((prev) =>
      prev.map((i) => ((i.key || i.id) === key ? { ...i, quantity: Math.max(1, quantity) } : i))
    );
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.quantity, 0);
  const payItems = useMemo(() => items.filter((i) => !i.consult), [items]);
  const consultItems = useMemo(() => items.filter((i) => i.consult), [items]);
  const total = payItems.reduce((s, i) => s + i.price * i.quantity, 0);

  const value = useMemo(
    () => ({ items, payItems, consultItems, addItem, removeItem, setQuantity, clear, count, total }),
    [items, payItems, consultItems, addItem, removeItem, setQuantity, clear, count, total]
  );

  return (
    <CartContext.Provider value={value}>
      {children}
    </CartContext.Provider>
  );
};
